var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSketchyBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 1439,
    viewBox: "0 0 1500 1439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1108.55 1230.95H171.098C121.826 1230.95 81.8828 1270.89 81.8828 1320.16V1347.94C81.8828 1397.21 121.826 1437.15 171.098 1437.15H1108.55C1157.82 1437.15 1197.76 1397.21 1197.76 1347.94V1320.16C1197.76 1270.89 1157.82 1230.95 1108.55 1230.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.21 1249.14H173.395C132.815 1249.14 99.9185 1282.03 99.9185 1322.61V1345.49C99.9185 1386.07 132.815 1418.97 173.395 1418.97H1106.21C1146.79 1418.97 1179.69 1386.07 1179.69 1345.49V1322.61C1179.69 1282.03 1146.79 1249.14 1106.21 1249.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.73 1401.6C1128.04 1401.6 1158.28 1371.36 1158.28 1334.05C1158.28 1296.75 1128.04 1266.5 1090.73 1266.5C1053.43 1266.5 1023.18 1296.75 1023.18 1334.05C1023.18 1371.36 1053.43 1401.6 1090.73 1401.6Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.875 1401.6C226.182 1401.6 256.425 1371.36 256.425 1334.05C256.425 1296.75 226.182 1266.5 188.875 1266.5C151.568 1266.5 121.324 1296.75 121.324 1334.05C121.324 1371.36 151.568 1401.6 188.875 1401.6Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.18 1266.5H274.461V1401.63H1005.18V1266.5Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.76 1168.81H1.85172V1230.95H1277.76V1168.81Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85172 1119.52V1168.81H1277.76V1119.52L1161.06 1002.8H118.547L1.85172 1119.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M847.9 1002.8H431.709V1168.81H847.9V1002.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.547 1002.8V969.097C118.547 969.097 191.356 964.987 209.244 1002.8",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.91 1002.8V969.097C1160.91 969.097 1088.1 964.987 1070.22 1002.8",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M282.868 979.355H263.684V1002.8H282.868V979.355Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M308.755 934.51H237.76L241.908 979.356H304.607L308.755 934.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M307.718 945.508H238.797",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.7 979.355H996.519V1002.8H1015.7V979.355Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.59 934.51H970.632L974.78 979.356H1037.44L1041.59 934.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.59 945.508H971.632",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.5 259.3H1266.31V282.741H1285.5V259.3Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.38 214.417H1240.39L1244.54 259.3H1307.24L1311.38 214.417Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.35 225.416H1241.43",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85172 1119.52V903.847H419.45V1002.8",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2575 1098.12V925.251H398.045V1002.8",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.76 1120.6V904.958H860.159V1003.91",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.35 1098.12V925.251H881.564V1002.8",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M556.514 1002.8V934.139",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M650.618 791.157C681.69 799.23 706.318 827.19 708.318 861.852V1002.8",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M611.658 954.099C659.233 954.099 697.8 915.535 697.8 867.962C697.8 820.39 659.233 781.825 611.658 781.825C564.084 781.825 525.517 820.39 525.517 867.962C525.517 915.535 564.084 954.099 611.658 954.099Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M563.18 796.712L533.331 568.186",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M704.874 842.966L643.878 630.66",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M617.621 625.993C658.712 625.993 692.023 592.684 692.023 551.596C692.023 510.507 658.712 477.198 617.621 477.198C576.53 477.198 543.219 510.507 543.219 551.596C543.219 592.684 576.53 625.993 617.621 625.993Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M886.971 479.161L675.024 616.106L662.432 623.957C648.471 632.659 632.398 637.77 615.954 637.474C614.325 637.474 612.658 637.362 611.029 637.251C569.069 634.104 534.96 599.849 531.998 557.854C529.998 529.525 541.738 503.824 561.255 486.826L565.477 483.938C571.958 479.494 578.957 475.902 586.364 473.273L850.344 380.062",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M894.267 467.866C920.529 467.866 941.819 446.577 941.819 420.316C941.819 394.055 920.529 372.767 894.267 372.767C868.005 372.767 846.715 394.055 846.715 420.316C846.715 446.577 868.005 467.866 894.267 467.866Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.69 414.169C1221.69 414.169 916.525 476.865 913.673 477.605C875.528 487.641 838.605 462.607 833.161 430.648C827.716 398.652 854.27 362.472 894.304 359.509C1008.41 352.769 1107.58 345.585 1221.69 338.845",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.87 384.062C1257.53 384.062 1266.17 375.424 1266.17 364.768C1266.17 354.112 1257.53 345.474 1246.87 345.474C1236.21 345.474 1227.58 354.112 1227.58 364.768C1227.58 375.424 1236.21 384.062 1246.87 384.062Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.87 394.801C1263.46 394.801 1276.91 381.355 1276.91 364.768C1276.91 348.181 1263.46 334.735 1246.87 334.735C1230.28 334.735 1216.84 348.181 1216.84 364.768C1216.84 381.355 1230.28 394.801 1246.87 394.801Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.68 371.693H1291.94",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.65 348.474V319.885C1221.65 299.369 1238.32 282.741 1258.8 282.741H1392.9V371.73H1298.64V434.944H1221.65V381.099",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.64 282.741V371.73",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.21 317H1393V337.664H1498.21V317Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.19 316.885V1.85156H1492.45V1418.97H1430.19V337.549",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchyBackground);
export default __webpack_public_path__ + "static/media/sketchy_background.f445144e6ae7d7454b6e37dab3051885.svg";
export { ForwardRef as ReactComponent };